/** @module app.demo */

import { autoinject, PLATFORM } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { AppModule } from 'app/shared/config/modules';
import { IDemoRouteConfig } from 'app/demo/lib/router-types';

@autoinject
export class DemoModule extends AppModule {

    public readonly code = 'demo';

    constructor(private readonly logger: AppLogger) {
        super();

        logger.source = this;
    }

    public getRoutes(): IDemoRouteConfig[] {
        return [
            { route: 'demo', name: 'demo', moduleId: PLATFORM.moduleName('app/demo/pages/demo-page'), title: 'Demo', settings: { bypassAuthentication: true } },
            { route: 'demo/elements', name: 'demo.elements', moduleId: PLATFORM.moduleName('app/demo/pages/demo-elements-page'), title: 'Demo: Custom Elements', settings: { bypassAuthentication: true } },
            { route: 'demo/components', name: 'demo.components', moduleId: PLATFORM.moduleName('app/demo/pages/demo-components-page'), title: 'Demo: Components', settings: { bypassAuthentication: true } },
            { route: 'demo/attributes', name: 'demo.attributes', moduleId: PLATFORM.moduleName('app/demo/pages/demo-attributes-page'), title: 'Demo: Attributes', settings: { bypassAuthentication: true } },
        ];
    }

}
